import { Banner, Skeleton } from '@fourthwall/components';
import dayjs from 'dayjs';
import React from 'react';
import { isPaidTier } from '../../../../utils';
import { useTierContext } from '../../hooks/useTierContext';
import { currencyDecimalPlaces } from '../../providers/TierProvider/consts';
import { getExchangeRate } from '../../utils';
import { UpdateCurrencyConversion } from '../UpdateCurrencyConversion';
import * as S from './styled';
export const DefaultExchangeRate = () => {
    const { tier, form, enabledCurrencies, priceRates, updatedCurrencyConversion, isPriceRatesLoading, } = useTierContext();
    if (!tier)
        return null;
    if (!form.values.price)
        return null;
    if (!('pricesAutomaticallyConverted' in tier))
        return;
    if (!enabledCurrencies)
        return null;
    if (!isPaidTier(tier))
        return null;
    if (enabledCurrencies.length === 0)
        return null;
    if (form.values.convertInternationalPricing === false)
        return null;
    if (updatedCurrencyConversion && form.values.price === form.initialValues.price) {
        return (React.createElement(S.Container, null,
            React.createElement(S.DefaultPricing, null,
                React.createElement("p", null,
                    "Based on ",
                    dayjs().format('MMM D, YYYY'),
                    " exchange rate:"),
                React.createElement("p", null, enabledCurrencies
                    .map((currency) => `${currency} ${getExchangeRate(currency, updatedCurrencyConversion)}`)
                    .join(', ')),
                React.createElement("p", null,
                    React.createElement(UpdateCurrencyConversion, null)))));
    }
    if (form.values.convertInternationalPricing === true &&
        form.values.convertInternationalPricing === form.initialValues.convertInternationalPricing &&
        form.values.price === form.initialValues.price) {
        const withoutUsdAndDisabledCurrencies = Object.fromEntries(Object.entries(tier.variants.monthly.amounts).filter(([key]) => key !== 'usd' &&
            enabledCurrencies.indexOf(key.toUpperCase()) > -1));
        const setAt = dayjs(tier.variants.monthly.amounts.usd.setAt).format('MMM D, YYYY');
        return (React.createElement(S.Container, null,
            React.createElement(S.DefaultPricing, null,
                React.createElement("p", null,
                    "Based on ",
                    dayjs(setAt).format('MMM D, YYYY'),
                    " exchange rate:"),
                React.createElement("p", null, Object.keys(withoutUsdAndDisabledCurrencies)
                    .map((currency) => {
                    const currencySymbol = currency;
                    const amount = tier.variants.monthly.amounts[currencySymbol].amount;
                    const exchangeRate = amount / 10 ** currencyDecimalPlaces[currencySymbol];
                    return `${currency.toUpperCase()} ${exchangeRate}`;
                })
                    .join(', ')),
                form.values.price != form.initialValues.price && (React.createElement("div", { style: { margin: '16px 0' } },
                    React.createElement(Banner, { appearance: "warning" }, "You have updated the price of this tier. You need to update the currency conversion to see the new international prices."))),
                React.createElement("p", null,
                    React.createElement(UpdateCurrencyConversion, null)))));
    }
    if (isPriceRatesLoading) {
        return (React.createElement(S.Container, null,
            React.createElement(S.DefaultPricing, null,
                React.createElement(Skeleton.Shape, { height: 42, width: 400 }))));
    }
    if (!priceRates)
        return (React.createElement(S.Container, null,
            React.createElement(Banner, { appearance: "danger", title: "We couldn't load exchange rates. Try refreshing the page." })));
    return (React.createElement(S.Container, null,
        React.createElement(S.DefaultPricing, null,
            React.createElement("p", null,
                "Based on ",
                dayjs().format('MMM D, YYYY'),
                " exchange rate:"),
            enabledCurrencies
                .map((currency) => `${currency} ${getExchangeRate(currency, priceRates)}`)
                .join(', '))));
};
